import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 200rem)',
  flex: 1,
  gap: '16rem',
});

export const MapContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  paddingInline: '15%',
});
